/* VBCAT — Web3Forms quote form behaviour */
(function () {
  var MAX_BYTES = 5 * 1024 * 1024; // Web3Forms default uploader limit: 5MB, single file
  var ENDPOINT = "https://api.web3forms.com/submit";

  function combineDate(form) {
    var hidden = form.querySelector("input[data-needed-by]");
    if (!hidden) return;
    var parts = form.querySelectorAll(".vbq-date");
    var v = { mm: "", dd: "", yyyy: "" };
    parts.forEach(function (p) { v[p.dataset.part] = (p.value || "").trim(); });
    hidden.value = (v.mm || v.dd || v.yyyy) ? (v.mm + "/" + v.dd + "/" + v.yyyy) : "";
  }

  function showError(form, msg) {
    var el = form.querySelector(".vbq-error");
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
  }
  function hideError(form) {
    var el = form.querySelector(".vbq-error");
    if (el) el.hidden = true;
  }

  function initSelects(form) {
    form.querySelectorAll("select").forEach(function (sel) {
      var sync = function () {
        if (sel.value === "") sel.classList.add("vbq-select--empty");
        else sel.classList.remove("vbq-select--empty");
      };
      sync();
      sel.addEventListener("change", sync);
    });
  }

  function initUpload(form) {
    var input = form.querySelector('input[type="file"]');
    if (!input) return;
    var box = input.closest(".vbq-uploadbox");
    var text = box ? box.querySelector(".vbq-uploadbox__text") : null;
    input.addEventListener("change", function () {
      if (!text) return;
      if (input.files && input.files.length) {
        text.textContent = input.files[0].name;
        if (box) box.classList.add("is-selected");
      } else {
        text.textContent = text.getAttribute("data-default") || "Add file";
        if (box) box.classList.remove("is-selected");
      }
    });
  }

  function initForm(form) {
    if (form.dataset.vbqInit) return;
    form.dataset.vbqInit = "1";

    initSelects(form);
    initUpload(form);

    var btn = form.querySelector(".vbq-submit");
    var wrap = form.closest(".vbcat-w3form-wrap");
    var success = wrap ? wrap.querySelector(".vbq-success") : null;

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      hideError(form);

      // Native validation (required fields, email format)
      if (typeof form.checkValidity === "function" && !form.checkValidity()) {
        form.reportValidity();
        return;
      }

      combineDate(form);

      // File checks
      var fileInput = form.querySelector('input[type="file"]');
      if (fileInput && fileInput.files && fileInput.files.length) {
        if (fileInput.files.length > 1) {
          showError(form, "Please attach a single file (up to 5MB).");
          return;
        }
        if (fileInput.files[0].size > MAX_BYTES) {
          showError(form, "That file is too large. Please attach a file under 5MB, or email it to Sales@VerifiedBreakers.com.");
          return;
        }
      }

      var originalLabel = btn ? btn.innerHTML : "";
      if (btn) { btn.disabled = true; btn.innerHTML = "Sending\u2026"; }

      var data = new FormData(form);

      // Do NOT set Content-Type — the browser adds the multipart boundary for file uploads.
      fetch(ENDPOINT, { method: "POST", body: data })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (res) {
          if (res.ok && res.json && res.json.success) {
            form.reset();
            form.hidden = true;
            if (success) {
              success.hidden = false;
              try { success.scrollIntoView({ behavior: "smooth", block: "center" }); } catch (err) {}
            }
          } else {
            var m = (res.json && res.json.message) ? res.json.message : "Something went wrong. Please try again or call 1-800-905-2170.";
            showError(form, m);
            if (btn) { btn.disabled = false; btn.innerHTML = originalLabel; }
          }
        })
        .catch(function () {
          showError(form, "Network error. Please try again or call 1-800-905-2170.");
          if (btn) { btn.disabled = false; btn.innerHTML = originalLabel; }
        });
    });
  }

  function initAll() {
    document.querySelectorAll(".vbcat-w3form").forEach(initForm);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  // Re-init inside the Shopify theme editor when sections reload
  document.addEventListener("shopify:section:load", initAll);
})();
